import {computed} from 'vue';
import type {Pinia} from 'pinia';
import {useNuxtApp} from '#app';
import {useHead, useAsyncData, useRoute, useRouter} from '#imports';
import type {RouteLocation} from '#vue-router';
import type {LightUser} from '../models/User';
import {useAuth} from '../store/auth.store';

export interface ImmersionOwnerRequest {
    id: string;
    type: 'IDENTITY_ID' | 'ACCOUNT_ID';
}

const IMMERSION_HEADER_NAME = 'X-Immersion-Identity';
export const IMMERSION_QUERY_PARAM = 'immersion';

type HTTPHeaders = {[key: string]: string};

export function useImmersionMode() {
    const nuxtApp = useNuxtApp();
    const {$pinia} = nuxtApp;
    const store = useAuth($pinia as Pinia);
    const route = useRoute();
    const router = useRouter();

    async function getImmersionOwner(request: ImmersionOwnerRequest) {
        const {data: userInImmersion} = await useAsyncData('immersion-owner', () => store.getImmersionOwner(request));
        return userInImmersion.value;
    }

    function setImmersionFrame(user: LightUser | null | undefined) {
        useHead({bodyAttrs: {class: 'immersion-mode', 'data-immersion-user': user?.fullName ?? ''}});
    }

    function getImmersionHeaderFromCurrentRoute(currentRoute: RouteLocation): HTTPHeaders {
        return currentRoute.query[IMMERSION_QUERY_PARAM] ? {[IMMERSION_HEADER_NAME]: currentRoute.query[IMMERSION_QUERY_PARAM] as string} : {};
    }

    const immersionHeaderFromCurrentRoute = computed(() => {
        return route.query[IMMERSION_QUERY_PARAM] ? {[IMMERSION_HEADER_NAME]: route.query[IMMERSION_QUERY_PARAM] as string} : {};
    });

    const currentUrlWithoutImmersion = computed(() => {
        const {[IMMERSION_QUERY_PARAM]: _, ...queryParams} = route.query;
        return router.resolve({path: route.path, query: queryParams}).href;
    });

    return {
        getImmersionOwner,
        setImmersionFrame,
        getImmersionHeaderFromCurrentRoute,

        immersionHeaderFromCurrentRoute,
        currentUrlWithoutImmersion,
    };
}
